import React, { Component } from 'react';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import Clients from '../../../views/clients/components/Clients'
import AccountingConfiguration from '../../../views/accountingConfiguration/components/AccountingConfiguration'
import Employees from 'views/employee/components/Employees';
import Vendors from 'views/vendor/components/Vendors';
import Locations from 'views/location/components/Locations';
import Inventories from 'views/inventory/components/Inventories';
import Assets from 'views/asset/components/asset/Assets';
import CreateOrUpdateAsset from 'views/asset/components/asset/CreateOrUpdateAsset';
import DepreciationRates from 'views/asset/components/rate/DepreciationRates';
import AssetHistory from 'views/asset/components/assetHistory/AssetHistory';
import InventorySummary from 'views/inventory/components/InventorySummary';
import DataImport from 'views/importData/components/DataImport';
import Recycling from 'views/recycling/components/Recycling';
import InactiveAssets from 'views/recycling/components/InactiveAssets';
import Users from 'views/users/components/Users';
import Audit from 'views/audit/components/Audit';
import ChangeLogs from 'views/audit/components/ChangeLogs';
import Home from '../Home';

class Content extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        return (
            <main className="content">
                <Switch>
                    <Route exact path="/" render={() => <Redirect to="/home" />} />
                    <Route exact path='/home' render={(props) => <Home {...props} userInfo={this.props.userInfo} />} />
                    <Route exact path='/clients' render={(props) => <Clients {...props} />} />
                    <Route exact path='/users' render={(props) => <Users {...props} />} />
                    <Route exact path='/accountingConfiguration' render={(props) => <AccountingConfiguration {...props} />} />
                    <Route exact path='/employees' render={(props) => <Employees {...props} />} />
                    <Route exact path='/vendors' render={(props) => <Vendors {...props} />} />
                    <Route exact path='/locations' render={(props) => <Locations {...props} />} />
                    <Route exact path='/inventories' render={(props) => <Inventories {...props} />} />
                    <Route exact path='/summaries' render={(props) => <InventorySummary {...props} />} />
                    <Route exact path='/assets' render={(props) => <Assets {...props} />} />
                    <Route exact path='/asset/:id' render={(props) => <CreateOrUpdateAsset {...props} />} />
                    <Route exact path='/assetRate/:id' render={(props) => <DepreciationRates {...props} />} />
                    <Route exact path='/asset' render={(props) => <CreateOrUpdateAsset {...props} />} />
                    <Route exact path='/history/:id' render={(props) => <AssetHistory {...props} />} />
                    <Route exact path='/import' render={(props) => <DataImport {...props} />} />
                    <Route exact path='/recycling' render={(props) => <Recycling {...props} />} />
                    <Route exact path='/inactive-assets' render={(props) => <InactiveAssets {...props} />} />
                    <Route exact path='/audit' render={(props) => <Audit {...props} />} />
                    <Route exact path='/change-logs' render={(props) => <ChangeLogs {...props} />} />
                    <Redirect to="/home" />
                </Switch>
            </main>
        );
    }
}

export default withRouter(Content);
